import styled from 'styled-components';
import { spacing, colors } from 'ui/theme';
import { pxToRem } from 'utils/convert';
import { FormField } from 'ui/formField';
import { IconButton } from 'ui/button';
import { BasicSelectField } from 'lib/iterable-hook-form';

export const Container = styled.div`
  display: grid;
  grid-gap: ${spacing.base};
  padding-bottom: ${pxToRem(80)};
`;

export const GreyContainer = styled.div`
  background-color: ${colors.grey1};
  border-radius: ${spacing.half};
  padding: ${spacing.base};
`;

export const FormFieldNoMargin = styled(FormField)`
  && {
    margin-top: 0;
  }
`;

export const BasicSelectFieldFullWidth = styled(BasicSelectField)`
  width: 100%;
`;

export const DeleteButton = styled(IconButton)`
  align-self: start;
`;

export const Columns = styled.div<{ hideDelete?: boolean }>`
  display: grid;
  ${({ hideDelete = false }) =>
    hideDelete
      ? `grid-template-columns: 1fr 1fr ${pxToRem(108)};`
      : `grid-template-columns: 1fr 1fr ${pxToRem(108)} auto;`}
  grid-gap: ${spacing.base};
  margin-bottom: ${spacing.base};
`;
